import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

export const RecordingSettingButtons = ({
  activeTab,
  onTabChange,
  buttonText,
}: {
  activeTab: string;
  onTabChange: (tab: string) => void;
  buttonText?: string;
}) => {
  return (
    <ButtonGroup className={'mb-4'}>
      <Button
        key={'settings'}
        onClick={() => {
          onTabChange('settings');
        }}
        variant={activeTab === 'settings' ? 'primary' : 'secondary'}
      >
        <span className="ml-2">Settings</span>
      </Button>
      <Button
        key={'recordedMessages'}
        onClick={() => {
          onTabChange('recordedMessages');
        }}
        variant={activeTab === 'recordedMessages' ? 'primary' : 'secondary'}
      >
        <span className="ml-2">{buttonText ? buttonText : 'Recorded Messages'}</span>
      </Button>
    </ButtonGroup>
  );
};
